import { render, staticRenderFns } from "./StudentsStats.vue?vue&type=template&id=e0299288&scoped=true&"
import script from "./StudentsStats.vue?vue&type=script&lang=js&"
export * from "./StudentsStats.vue?vue&type=script&lang=js&"
import style0 from "./StudentsStats.vue?vue&type=style&index=0&id=e0299288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0299288",
  null
  
)

export default component.exports